// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downtext[data-v-0454387c] {\n  position: absolute;\n  left: 100px;\n  top: -27px;\n  color: #082dc3;\n  text-decoration: underline;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
